import { useMemo } from "react";

export interface Installment {
  quantity: number;
  value: number;
}

export interface PaymentMethod {
  code: number;
  description: string;
  installments: Installment[];
}

export interface Package {
  code: number;
  description: string;
  paymentMethods: PaymentMethod[];
}

// Fallback sample data (only used if quotes don't have installment data)
const SAMPLE_PACKAGES: Package[] = [
  {
    code: 1,
    description: "Compacto",
    paymentMethods: [
      {
        code: 1,
        description: "Débito em conta bancária ",
        installments: [
          { quantity: 1, value: 1377.49 },
          { quantity: 2, value: 688.74 },
          { quantity: 3, value: 459.16 },
          { quantity: 4, value: 344.37 },
          { quantity: 5, value: 275.49 },
          { quantity: 6, value: 229.58 },
          { quantity: 7, value: 196.78 },
          { quantity: 8, value: 172.18 },
          { quantity: 9, value: 153.05 },
          { quantity: 10, value: 137.74 },
        ],
      },
      {
        code: 2,
        description: "Boleto                   ",
        installments: [
          { quantity: 1, value: 1377.49 },
          { quantity: 2, value: 688.74 },
          { quantity: 3, value: 459.16 },
          { quantity: 4, value: 344.37 },
          { quantity: 5, value: 289.27 },
          { quantity: 6, value: 244.43 },
          { quantity: 7, value: 212.27 },
          { quantity: 8, value: 187.15 },
          { quantity: 9, value: 168.72 },
          { quantity: 10, value: 153.78 },
        ],
      },
      {
        code: 4,
        description: "Cartão                   ",
        installments: [
          { quantity: 1, value: 1377.49 },
          { quantity: 2, value: 688.74 },
          { quantity: 3, value: 459.16 },
          { quantity: 4, value: 344.37 },
          { quantity: 5, value: 275.49 },
          { quantity: 6, value: 229.58 },
          { quantity: 7, value: 196.78 },
          { quantity: 8, value: 172.18 },
          { quantity: 9, value: 153.05 },
          { quantity: 10, value: 137.74 },
        ],
      },
    ],
  },
  {
    code: 7,
    description: "Ampliado",
    paymentMethods: [
      {
        code: 1,
        description: "Débito em conta bancária ",
        installments: [
          { quantity: 1, value: 1361.37 },
          { quantity: 2, value: 680.68 },
          { quantity: 3, value: 453.78 },
          { quantity: 4, value: 340.34 },
          { quantity: 5, value: 272.27 },
          { quantity: 6, value: 226.89 },
          { quantity: 7, value: 194.48 },
          { quantity: 8, value: 170.17 },
          { quantity: 9, value: 151.26 },
          { quantity: 10, value: 136.13 },
        ],
      },
      {
        code: 2,
        description: "Boleto                   ",
        installments: [
          { quantity: 1, value: 1361.37 },
          { quantity: 2, value: 680.68 },
          { quantity: 3, value: 453.78 },
          { quantity: 4, value: 340.34 },
          { quantity: 5, value: 286.15 },
          { quantity: 6, value: 241.42 },
          { quantity: 7, value: 209.21 },
          { quantity: 8, value: 185.48 },
          { quantity: 9, value: 166.70 },
          { quantity: 10, value: 151.29 },
        ],
      },
      {
        code: 4,
        description: "Cartão                   ",
        installments: [
          { quantity: 1, value: 1361.37 },
          { quantity: 2, value: 680.68 },
          { quantity: 3, value: 453.78 },
          { quantity: 4, value: 340.34 },
          { quantity: 5, value: 272.27 },
          { quantity: 6, value: 226.89 },
          { quantity: 7, value: 194.48 },
          { quantity: 8, value: 170.17 },
          { quantity: 9, value: 151.26 },
          { quantity: 10, value: 136.13 },
        ],
      },
    ],
  },
  {
    code: 5,
    description: "Exclusivo",
    paymentMethods: [
      {
        code: 1,
        description: "Débito em conta bancária ",
        installments: [
          { quantity: 1, value: 1380.32 },
          { quantity: 2, value: 690.16 },
          { quantity: 3, value: 460.10 },
          { quantity: 4, value: 345.08 },
          { quantity: 5, value: 276.06 },
          { quantity: 6, value: 230.05 },
          { quantity: 7, value: 197.18 },
          { quantity: 8, value: 172.54 },
          { quantity: 9, value: 153.36 },
          { quantity: 10, value: 138.03 },
        ],
      },
      {
        code: 2,
        description: "Boleto                   ",
        installments: [
          { quantity: 1, value: 1380.32 },
          { quantity: 2, value: 690.16 },
          { quantity: 3, value: 460.10 },
          { quantity: 4, value: 345.08 },
          { quantity: 5, value: 289.86 },
          { quantity: 6, value: 244.48 },
          { quantity: 7, value: 212.09 },
          { quantity: 8, value: 187.81 },
          { quantity: 9, value: 168.94 },
          { quantity: 10, value: 153.86 },
        ],
      },
      {
        code: 4,
        description: "Cartão                   ",
        installments: [
          { quantity: 1, value: 1380.32 },
          { quantity: 2, value: 690.16 },
          { quantity: 3, value: 460.10 },
          { quantity: 4, value: 345.08 },
          { quantity: 5, value: 276.06 },
          { quantity: 6, value: 230.05 },
          { quantity: 7, value: 197.18 },
          { quantity: 8, value: 172.54 },
          { quantity: 9, value: 153.36 },
          { quantity: 10, value: 138.03 },
        ],
      },
    ],
  },
];

export const useHomeownersInstallments = (quotes: Quote[]) => {
  const packages = useMemo(() => {
    if (!quotes || quotes.length === 0) {
      console.warn("No quotes available, using sample packages");
      return SAMPLE_PACKAGES;
    }

    try {
      // Extract packages from the first 3 quotes' allianzInstallmentsResponse
      const allPackages: Package[] = [];
      
      // Take first 3 quotes (or less if there aren't 3)
      const quotesToProcess = quotes.slice(0, 3);
      
      quotesToProcess.forEach((quote) => {
        const installmentsResponse = quote?.data?.allianzInstallmentsResponse;
        
        if (installmentsResponse?.quoteResponse?.return?.value?.packages) {
          const quotePackages = installmentsResponse.quoteResponse.return.value.packages;
          
          // Add each package from this quote
          quotePackages.forEach((pkg: Package) => {
            // Check if we already have this package (by code) to avoid duplicates
            const existingPackage = allPackages.find((p) => p.code === pkg.code);
            
            if (!existingPackage) {
              // Clean up the description (trim whitespace)
              allPackages.push({
                ...pkg,
                description: pkg.description.trim(),
              });
            }
          });
        }
      });

      // If we found packages, return them; otherwise use sample data
      if (allPackages.length > 0) {
        console.log(`Loaded ${allPackages.length} packages from quotes`);
        return allPackages;
      } else {
        console.warn("No installment data found in quotes, using sample packages");
        return SAMPLE_PACKAGES;
      }
    } catch (err) {
      console.error("Error parsing homeowners installments from quotes:", err);
      return SAMPLE_PACKAGES;
    }
  }, [quotes]);

  return { packages };
};

export default useHomeownersInstallments;

